export default __webpack_public_path__ + "static/media/icon.21e97fb0.png";